import React from 'react';

export default function Experience() {
  const experiences = [
    {
      company: "Reliance Jio",
      role: "Software Engineer Manager",
      period: "Sep 2022 – Jul 2024",
      location: "Mumbai (Onsite)",
      description: [
        "Managed and developed core 5G network systems with Java, Spring Boot, SIGTRAN, and WebSocket",
        "Built CLI tools for real-time 5G traffic monitoring and simulators for load testing",
        "Mentored junior engineers in scalable software design best practices",
        "Deployed on AWS ECS with SNS/SQS integrations for anomaly detection"
      ],
      technologies: ["Java", "Spring Boot", "AWS", "SIGTRAN", "5G"],
      color: "from-pink-500 to-red-500",
      icon: "📡"
    },
    {
      company: "LTI",
      role: "Software Engineer",
      period: "Sep 2021 – Sep 2022",
      location: "Pune (Remote)",
      description: [
        "Developed credit card payment gateway using Java, Spring Boot, and microservices",
        "Resolved production issues, refactored code, and enhanced performance",
        "Integrated React frontend with REST APIs and implemented JWT authentication",
        "Built Kafka-based event streams for transaction tracking"
      ],
      technologies: ["Java", "Spring Boot", "React", "Kafka", "Microservices"],
      color: "from-green-500 to-emerald-500",
      icon: "💳"
    },
    {
      company: "MPHRX",
      role: "Software Engineer",
      period: "Dec 2020 – May 2021",
      location: "Gurgaon (Remote)",
      description: [
        "Built healthcare modules using Java, Spring Boot, microservices architecture",
        "Worked with SQL and NoSQL databases for patient data management",
        "Implemented secure medical record management and appointment systems"
      ],
      technologies: ["Java", "Spring Boot", "MongoDB", "MySQL", "JavaScript"],
      color: "from-purple-500 to-indigo-500",
      icon: "🏥"
    },
    {
      company: "Technoforte Software",
      role: "Associate Software Engineer",
      period: "Oct 2019 – Sep 2020",
      location: "Bangalore",
      description: [
        "Developed enterprise Logistics System using Java, Spring, JSP, and JavaScript",
        "Fixed bugs, enhanced features, and performed comprehensive testing",
        "Built dynamic reporting dashboards and custom workflow forms"
      ],
      technologies: ["Java", "JSP", "JavaScript", "JDBC", "Spring"],
      color: "from-orange-500 to-yellow-500",
      icon: "🚚"
    },
    {
      company: "Independent Software Consultant",
      role: "Freelance Software Engineer",
      period: "Oct 2016 – Mar 2019",
      location: "Muzaffarpur (Remote)",
      description: [
        "Developed custom applications using Java, Servlet, JSP, JDBC, and Hibernate",
        "Delivered end-to-end solutions: examination portals, payroll, inventory, CRM systems",
        "Managed entire project lifecycle from requirements to deployment and support"
      ],
      technologies: ["Java", "Servlet", "JSP", "Hibernate", "MySQL"],
      color: "from-cyan-500 to-blue-500",
      icon: "🚀"
    },
  ];

  return (
    <section className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
            Professional Journey
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Over 8 years of experience building scalable software solutions across telecom, fintech, healthcare, and enterprise domains
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-blue-200 to-purple-200 hidden lg:block"></div>
          
          {experiences.map((exp, index) => (
            <div key={index} className={`relative mb-12 lg:flex lg:items-center lg:justify-between ${
              index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
            }`}>
              {/* Timeline dot */}
              <div className="absolute left-1/2 transform -translate-x-1/2 w-6 h-6 bg-white border-4 border-blue-500 rounded-full z-10 hidden lg:block"></div>
              
              {/* Content Card */}
              <div className={`lg:w-5/12 bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden ${
                index % 2 === 0 ? 'lg:mr-8' : 'lg:ml-8'
              }`}>
                {/* Header */}
                <div className={`bg-gradient-to-r ${exp.color} p-6 text-white`}>
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center space-x-3">
                      <span className="text-2xl">{exp.icon}</span>
                      <h3 className="text-2xl font-bold">{exp.company}</h3>
                    </div>
                    <span className="bg-white/20 px-3 py-1 rounded-full text-sm font-medium">
                      {exp.period}
                    </span>
                  </div>
                  <h4 className="text-xl font-semibold opacity-90">{exp.role}</h4>
                  <p className="text-white/80">{exp.location}</p>
                </div>

                {/* Content */}
                <div className="p-6">
                  <ul className="space-y-3 mb-6">
                    {exp.description.map((item, i) => (
                      <li key={i} className="flex items-start space-x-3 text-gray-700">
                        <span className="text-green-500 mt-1">✓</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  
                  {/* Technologies */}
                  <div className="flex flex-wrap gap-2">
                    {exp.technologies.map((tech, i) => (
                      <span key={i} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-medium">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Spacer for mobile */}
              <div className="lg:w-5/12"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}